<template>
  <div class="issues-dialog">
    <div class="box">
      <div class="close-btn" @click="$emit('closeDialog')">
        <div class="shadow"></div>
      </div>
      
      <div class="form">
        <div class="topic">回報問題</div>
        <div class="required">*必填欄位</div>
        <el-form label-position="top" ref="form" :rules="rules" label-width="80px" :model="formLabelAlign">
          <el-form-item label="你發現了什麼問題?" prop="category_id">
            <div class="radio">
              <el-radio-group v-model="formLabelAlign.category_id">
                <el-radio  :label="its.id" v-for="(its, idx) in problem" :key="idx">{{ its.name }}</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="描述問題" prop="description">
            <el-input type="textarea" v-model="formLabelAlign.description"></el-input>
          </el-form-item>
          <el-form-item label="請提供你的電郵地址" prop="email">
            <el-input v-model="formLabelAlign.email" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="submit-to" @click="save">提交</div>
    </div>
  </div>
</template>

<script>
// 
import {getQuestionFeedbackCategories, getQuestionFeedbacks} from '@/api/question.js'

export default {
  props: ['id'],
  data() {
    return {
      problem: [
        {lable: '題目錯誤', value: '0'},
        {lable: '發現錯字', value: '1'},
        {lable: '錯位或無法顯示', value: '2'},
        {lable: '其他問題', value: '3'},
      ],

      formLabelAlign: {
        question_id: this.id,
        category_id: [],
        description: '',
        email: ''
      },
      rules: {
        email: [
          { required: true, message: '請輸入電郵地址', trigger: 'blur' },
          { type: 'email', message: '請輸入正確的電郵地址', trigger: ['blur', 'change'] }
        ],
        description: [
          { required: true, message: '請輸入描述問題', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: '請選择問題类型', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    save() {
      let form = JSON.parse(JSON.stringify(this.formLabelAlign))
      // form.category_id = form.category_id[0]
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          getQuestionFeedbacks(form).then(() => {
            this.$message.success('提交成功!')
            this.$emit('closeDialog')
          })
        } 
      });
    }
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.formLabelAlign.student_id = userInfo.id
    getQuestionFeedbackCategories().then(res => {
      this.problem = res.data
    })
  }
}
</script>

<style scoped lang="scss">
.issues-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  .box {
    width: 800px;
    min-height: 500px;
    height: 60%;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    padding: 20px;
    .form {
      width: 100%;
      flex: 1;
      overflow: auto;

      .radio {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
    .close-btn {
      position: absolute;
      top: -19px;
      right: -17px;
      width: 35px;
      height: 37px;
      border-radius: 50px;
      background-color: #b5282c;
      cursor: pointer;

      &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 65%;
        height: 4px;
        border-radius: 4px;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:after {
        transform: rotateZ(-45deg);
      }
      .shadow {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50px;
        box-shadow: inset 0 -4px 0 0 #841515;
        transition: box-shadow .1s linear;
      }

      &:hover {
        // opacity: .7;
        .shadow {
          box-shadow: inset 0 -1px 0 0 #841515;
        }
      }
    }

    .required {
      color: #B62D2E;
      font-size: 16px;
    }
    .topic {
      width: 100%;
      text-align: center;
      font-size: 20px;
      color: #b5282c;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .submit-to {
      font-weight: 700;
      font-size: 18px;
      color: #333;
      width: 200px;
      height: 45px;
      line-height: 40px;
      border-radius: 50px;
      background-color: #ffb842;
      text-align: center;
      cursor: pointer;
      position: relative;
      margin: auto;

      &:hover {
        opacity: .7;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50px;
        box-shadow: inset 0 -5px 0 0 #c0811f;
      }
    }
  }
}
</style>

<style lang="scss">
.issues-dialog {
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before
  {
    content: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after
  {
    content: '*';
    color: #F56C6C;
    margin-left: 4px;
  }
}

.form {
  .el-form-item__label {
    font-size: 16px !important;
  }

  .el-radio__label {
    font-size: 16px !important;
  }
}
</style>